
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.4898 9.63C15.3298 7.21 14.4598 4.84 12.8498 2.87C12.4398 2.37 11.6898 2.37 11.2798 2.87C9.62982 4.85 8.70982 7.22 8.50982 9.63C9.78982 10.31 10.9698 11.19 11.9998 12.26C13.0298 11.2 14.2098 10.32 15.4898 9.63ZM8.98982 12.28C8.84982 12.18 8.68982 12.09 8.53982 11.99C8.68982 12.1 8.84982 12.18 8.98982 12.28ZM15.4098 12.03C15.2798 12.12 15.1398 12.19 15.0098 12.29C15.1398 12.19 15.2798 12.12 15.4098 12.03ZM11.9998 15.45C10.0498 12.48 6.85982 10.42 3.16982 10.06C2.52982 10 1.99982 10.53 2.05982 11.17C2.50982 15.97 5.70982 19.95 10.0398 21.5C10.6698 21.73 11.3298 21.9 12.0098 22.01C12.6898 21.89 13.3398 21.72 13.9798 21.5C18.3098 19.95 21.5098 15.98 21.9598 11.17C22.0198 10.53 21.4798 10 20.8498 10.06C17.1398 10.42 13.9498 12.48 11.9998 15.45Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-spa`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSpa

    ```js
    <b-new-b-icon-spa />
    ```
</docs>


